import { OutlinedInput } from '@mui/material';
import styled from 'styled-components';

import searchIcon from 'assets/images/searchIcon.png';

export const FilterInput = styled(OutlinedInput)`
  // padding: 0.4rem;
  background-image: url(${searchIcon});
  background-color: white;
  background-position: 10px 50%;
  background-repeat: no-repeat;
  background-size: auto calc(100% - 20px);
  input {
    width: calc(80% - 1em);
    margin-left: 1.8em;
  }
`;
